<div class="stellar-wrapper" #stellar
  [class.disabled]="disabled"
  [class.is-mobile]="isMobile"
  [class.has-pages]="totalPages > 1"
  [ngStyle]="!isMobile && {'transform': 'scale(' + scale + ')', 'margin' : verticalIntend }">

  <div class="stellar-wrapper__center"
    [class.no-pages]="totalPages === 1"
    [class.tooltip]="showTradeOffTooltip">
    <ng-container *ngIf="totalPages > 1">
      <i class="app-ico-mask app-ico-mask__btn-arrow-left" 
        (click)="(activePages - 1) !== 0 && switchPage(-1)"></i>
      <b>{{ activePages }}</b> <span>/</span> {{ totalPages }}
      <i class="app-ico-mask app-ico-mask__btn-arrow-right" 
        (click)="activePages !== totalPages && switchPage(1)"></i>
    </ng-container>
    <div class="stellar-wrapper__center__no-slider" *ngIf="totalPages === 1"></div>
  </div>
  <div class="tooltiptext" *ngIf="showTradeOffTooltip">
    {{ showTradeOffTooltip }}
  </div>

  <div class="stellar"
    [class.is-mobile]="isMobile"
    [ngClass]="viewSkills.length ? 'count-' + viewSkills.length : ''">
    <ng-container *ngFor="let skill of skillsForm.controls; let i = index;">
      <div class="stellar__ray" 
        [class.loading]="loading"
        [class.has-tradeoff]="tradeOffs[skill.get('catId').value].enabled && skill.get('experience').value !== 5">
        <div class="stellar__skill-title">{{ viewSkills[i].name }}</div>
        <div class="stellar__jun-label">Junior</div>
        <div class="stellar__sen-label">Senior</div>
        <div class="stellar__axis"></div>
        <div class="stellar__triangle">
          <span [ngStyle]="{ 'border-width' : '15px 0 14px ' + (skill.get('experience').value * 38) + 'px' }"></span>
        </div>
        <input type="range" min="1" class="tooltip"
          [max]="tradeOffs[skill.get('catId').value].enabled && skill.get('experience').value !== 5 ? 4 : 5"
          [style.width]="tradeOffs[skill.get('catId').value].enabled && skill.get('experience').value !== 5 ? '128px' : '160px'"
          [ngStyle]="{'--bg-color': skill.get('color').value }"
          [formControl]="getSkillValueByIndex(i)"
          (focus)="toggleFocus(tradeOffs[skill.get('catId').value].enabled && skill.get('experience').value !== 5 ? skill.get('catId').value : null)"
          (blur)="toggleFocus(null)"
          (input)="valueChanged($event, skill.get('id').value)">
        <div class="tooltiptext" *ngIf="isMobile && showTradeOffTooltip">
          {{ showTradeOffTooltip }}
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="stellar-legend" [class.is-mobile]="isMobile">
  <div class="stellar-legend__item" *ngFor="let level of experienceLevels">
    <span class="stellar-legend__dot" [ngStyle]="{'background-color': '#c9eaa4'}" *ngFor="let star of getStars(level.value)"></span>
    <span class="stellar-legend__label">{{ level.label }}</span>
  </div>
</div>

<div class="stellar-categories" *ngIf="categoryList.length">
  <div *ngFor="let category of categoryList">
    <span [style.background]="category.color"></span> {{ category.name }}
  </div>
</div>